import { FC } from "react";
import { match, Route } from "react-router-dom";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import FEATURE_FLAGS from "src/utils/constants/featureFlags";
import __ from "src/utils/Translations";
import TilesMenu from "src/Components/TilesMenu";
import { CompanySubMenu } from "src/Layout/AppNav/SubMenuItems";
import { getCompanyBaseBreadcrumbs } from "src/Pages/Company/routerHelper";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import Widgets from "src/Pages/Company/Dashboard/pages/Widgets";
import { theme } from "src/theme/theme";
import { PermissionsContextProvider } from "src/utils/Permissions/PermissionsContext";
import { GlobalModalContextProvider } from "src/utils/GlobalModal/GlobalModalContext";
import { ThemeProvider } from "@mui/material";
import { getLanguage } from "src/utils/Languages/LanguageContext";

type DashboardRoutesProps = {
  match: match;
  // eslint-disable-next-line
  location: any;
};

const DashboardRoutes: FC<DashboardRoutesProps> = ({ match, location }) => {
  const companyId = useCompanyId();
  const language = getLanguage();
  const companyName = useCompanyName();
  const baseBreadcrumbs = getCompanyBaseBreadcrumbs(companyId, companyName);
  const baseDashboardUrl = `${match.url}/dashboard`;
  const isDashboardModuleEnabled = useFeatureIsOn(
    FEATURE_FLAGS.DASHBOARD_VISIBILITY
  );
  const isDashboardWidgetsEnabled = useFeatureIsOn(
    FEATURE_FLAGS.DASHBOARD_WIDGETS
  );

  const config = CompanySubMenu.getConfig(location.pathname);
  const customConfig =
    config.find((el) => el.id === "dashboard")?.content ?? [];

  if (!isDashboardModuleEnabled) {
    return null;
  }

  return (
    <>
      <ThemeProvider theme={theme({ language })}>
        <PermissionsContextProvider>
          <GlobalModalContextProvider>
            {isDashboardWidgetsEnabled ? (
              <Route
                exact
                path={baseDashboardUrl}
                render={() => (
                  <TilesMenu
                    config={customConfig}
                    title={__("Dashboard")}
                    breadcrumbs={baseBreadcrumbs}
                  />
                )}
              />
            ) : null}
            {isDashboardWidgetsEnabled ? (
              <Route
                exact
                path={`${baseDashboardUrl}/widgets`}
                component={Widgets}
              />
            ) : null}
          </GlobalModalContextProvider>
        </PermissionsContextProvider>
      </ThemeProvider>
    </>
  );
};

export default DashboardRoutes;
